export function setSplit() {
    const splittxt = [...document.querySelectorAll(".js-splittxt")];

    for (const txt of splittxt) {
        const textContent = txt.textContent;
        const className = txt.parentNode.getAttribute("data-sectionttl") === "1" ? "c-splittxt c-splitttl" : "c-splittxt";
        const newTextContent = [...textContent].map((char) => `<span class="${className}">${char}</span>`).join("");
        txt.innerHTML = newTextContent;
    }
}
